import React from 'react';
import BaseStep from 'high-school-student/account-conversion/components/base-step';
import {Answer, Question} from '../types';
import FormikTextField from 'src/components/FormikTextField/FormikTextField';
import {findIndex} from 'lodash';
import {useFormikContext} from 'formik';

const TextQuestion = (props: {question: Question}): React.ReactElement => {
  const {values} = useFormikContext<{answers: Answer[]}>();
  const index = findIndex(values.answers, {questionId: props.question._id});

  return (
    <BaseStep stepHeader={props.question.text} subHeader={props.question.subheading}>
      <FormikTextField type="textarea" name={`answers[${index}].content`} />
    </BaseStep>
  );
};

export default TextQuestion;
